import { Injectable } from '@angular/core';
import {LanguageService} from '../language/language.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DialogService } from '../dialog/dialog.service';
import { FormControl, FormGroup } from '@angular/forms';
import { IUnsavedChangesComponent } from 'src/app/guards/UnsavedChangesGuard';
import { environment } from 'src/environments/environment';
import { ImageFile } from 'src/app/_shared-components/image-upload/common/base-image-uploader';
import { bookingType } from 'src/app/utils/constant/constants';
import { DATETIME_FORMAT_REQUEST, FILTER_DEFAULT_END_TIME, FILTER_DEFAULT_START_TIME } from 'src/app/utils/constant';

export type TCanDeactivateComponents = {
  id: string,
  component: IUnsavedChangesComponent
}

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private canDeactiveComponents: Array<TCanDeactivateComponents> = [];
  private imageMaxFileUploadLimit = 1; //MB;
  private validRegistrationEmail;

  constructor(
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }

  // public initLocale(){
  //   let langs = _.map(LANGUAGES, 'value');
  //   this.translate.addLangs(langs);
    
  //   this.translate.setDefaultLang(DEFAULT_LANGUAGE);

  //   let lang;
    
  //   if(localStorage.getItem(KEY_STORAGE_LANGUAGE)){
  //     lang = localStorage.getItem(KEY_STORAGE_LANGUAGE);
  //   } else {
  //     if(_.indexOf(langs, this.translate.getBrowserLang()) >= 0){
  //       lang = this.translate.getBrowserLang();
  //     } else {
  //       lang = DEFAULT_LANGUAGE;
  //     }
  //     localStorage.setItem(KEY_STORAGE_LANGUAGE, DEFAULT_LANGUAGE);
  //   }

  //   this.translate.use(lang);
  // }

  // public getLocale(){
  //   return localStorage.getItem(KEY_STORAGE_LANGUAGE);
  // }

  // public updateLocale(locale){
  //   this.translate.use(locale);
  //   localStorage.setItem(KEY_STORAGE_LANGUAGE, locale);
  // }

  public randomString(n: number = 6){
   return Math.random().toString(36).substring(n);
  }

  public convertToLocalDatetime(objArr) {
    objArr.forEach(obj => {
      Object.keys(obj).forEach(function(key) {
        if(_.isString(obj[key]) && _.isNaN(_.toNumber(obj[key])) && moment(obj[key]).isValid()) {
          obj[key] = moment.utc(obj[key]).local();
        }
      });
    });
    return objArr;
  }

  public convertToBase64(data): string {
    let base64String: string = null;

    if (data != null && data != undefined && data != "") {
      base64String = btoa(data);
    }

    return base64String;
  }

  public currencyFormatter(amount:number){
    const formatter = new Intl.NumberFormat("en-US", {
      style:"currency",
      currency:"PHP"
    })

    return formatter.format(amount)
  }

  public showError(mode:string){
    switch (mode) {
      case "INTERNET":
        this.dialogService.openSnackBar("No Internet Connection. Please check your internet connection and try again.")
        break;
      case "NET_ERR":
        this.dialogService.openSnackBar("Network Error. Please try again.")
        break;
      case "SERVER_ERR":
        this.dialogService.openSnackBar("Server Error. Please try again.")
        break;
      case "DATA_ERR":
        this.dialogService.openSnackBar("Data Error. Please try again.")
        break;
      case "FIELD_ERR":
        this.dialogService.openSnackBar("Please fillout required fields of atleast the 1st step.")
        break;
      case "TIMEOUT_ERR":
        this.dialogService.openSnackBar("Session Timeout. Please login again.")
        break;
    }
  }

  /**
    * function to get the geolocation of the browser. has waiting time of about 5 secs
    * so make sure to run this function in advance.
    * @returns string
    */
  getGeolocation():string{

    let geolocation = "0"

    let options = {
       enableHighAccuracy: false,
       timeout: 5000,
       maximumAge: 0
    }

    navigator.geolocation.getCurrentPosition(
       function(pos){
          let crd = pos.coords;
          // variable within scope see above
          let location = crd.latitude + "," + crd.longitude
          // console.info("geolocation", location)
          geolocation = location
       }, 
       function(err){
          console.log(err.message);
          geolocation = "0"
       }, options)

    return geolocation;
    
 }

  public noWhitespaceValidator(control: FormControl) {
    let isValid = true;
    if (control.value && control.value.length > 0) {
      const isWhitespace = (control.value || '').trim().length === 0;
      isValid = !isWhitespace;
    }
    return isValid ? null : { 'whitespace': true };
  }

  public formatDateTimeToLocal(datetime) {
    return moment.utc(datetime).local().format('MM/DD/YYYY hh:mm A')
  }

  public formatAddress(address, city, state, country, zip, barangay=null) {
    let formattedAddress = (address ? address + ', ' : '') +
    (barangay ? barangay + ', ' : '') +
    (city ? city + ', ' : '') +
    (state ? state + ', ' : '') +
    (country ? country + ' ': '') +
    (zip ? zip : '') 
    return formattedAddress
  }

  public formatName(firstname, middlename, lastname, suffix) {
    let formattedName = firstname + ' ' +
    (middlename ? middlename + ' ' : '') +
    lastname + ' ' +
    (suffix ? suffix  : '')
    return formattedName
  }

  public formatFileNameS3(filename: string) {
    return filename.replace(/\s+/g, "-");
  }

  public getErrorCount(formGroup: FormGroup) {
    let count = 0;
    Object.keys(formGroup.controls).forEach(key => {
      if (formGroup.get(key).errors) {
        count += 1;
      }
    })
    return count;
  }

  public getDateTimeLocal({date = null, time = null, formatDateTime = "MM/DD/YYYY hh:mm A", dateOnly = false, formatDate = "MM/DD/YYYY", timeOnly = false, formatTime = "hh:mm A"}) {
    if (!date) {
      throw new Error("Date cant be null");
    }
    if (dateOnly && timeOnly) {
      throw new Error("Please enable only 1 mode; dateOnly or TimeOnly");
    }

    let datetime
    if (time) {
      datetime = moment(date).format('YYYY-MM-DD').toString() + " " + time;
    } else {
      datetime = moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
    }
    
    let localDateTime = moment.utc(datetime).local();

    if (dateOnly) {
      return localDateTime.format(formatDate)
    } else if (timeOnly) {
      return localDateTime.format(formatTime)
    } else {
      return localDateTime.format(formatDateTime)
    }
  }

  public getDateTimeUTC({date = null, time = null, formatDateTime = "MM/DD/YYYY hh:mm A", dateOnly = false, formatDate = "MM/DD/YYYY", timeOnly = false, formatTime = "hh:mm A"}) {
    
    if (!date) {
      throw new Error("Date cant be null");
    }
    if (dateOnly && timeOnly) {
      throw new Error("Please enable only 1 mode; dateOnly or TimeOnly");
    }

    let datetime
    if (time) {
      datetime = moment(date).format('YYYY-MM-DD').toString() + " " + time;
    } else {
      datetime = moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
    }
    
    let utcDateTime = moment(datetime).utc();

    if (dateOnly) {
      return utcDateTime.format(formatDate)
    } else if (timeOnly) {
      return utcDateTime.format(formatTime)
    } else {
      return utcDateTime.format(formatDateTime)
    }
  }

  /**
   * Function to set from date and to date for filter request
   * if monthCoverage, function will set fromDate and toDate to cover their whole month. sample: Jan 1 - Feb 28
   * if not monthCoverage, function will return the exact date as passed.
   * Automatically adds covering time. See FILTER_DEFAULT_START_TIME & FILTER_DEFAULT_END_TIME.
   * And formats to the accepted format of the Server.
   * @param param0 
   * @returns object
   */
  public getFilterComponentDateTimeRequestUTC({ fromDate, toDate = null, monthCoverage = true }) {
    let from_date = this.getDateTimeUTC({
      date: monthCoverage ? moment(fromDate).startOf('month') : moment(fromDate),
      time: FILTER_DEFAULT_START_TIME,
      formatDateTime: DATETIME_FORMAT_REQUEST
    })

    let to_date = null;

    if (!toDate) {
      to_date = this.getDateTimeUTC({
        date: monthCoverage ? moment(fromDate).endOf('month') : moment(fromDate),
        time: FILTER_DEFAULT_END_TIME,
        formatDateTime: DATETIME_FORMAT_REQUEST
      })
    } else {
      to_date = this.getDateTimeUTC({
        date: monthCoverage ? moment(toDate).endOf('month') : moment(toDate),
        time: FILTER_DEFAULT_END_TIME,
        formatDateTime: DATETIME_FORMAT_REQUEST
      })
    }

    return { from_date, to_date }

  }

  registerCanDeactivateComponent(id: string, component: IUnsavedChangesComponent) {
    const tComponent = {
      id: id,
      component: component
    }

    const exist = this.canDeactiveComponents.some(item => item.id === tComponent.id);
    
    if (exist) {
      if(!environment.production){console.log('%c' + 'Registering an existing component to helper\'s canDeactivateComponents. This is normal if you are reopening a component.', 'background: #bada55; color: #222');};
      return;
    }

    this.canDeactiveComponents.push(tComponent);
  }

  getRegisteredCanDeactivateComponents():IUnsavedChangesComponent[] {
    const components = this.canDeactiveComponents.map(item => {
      return item.component
    })
    return components ? components : null;
  }

  clearRegisteredCanDeactivateComponents() {
    this.canDeactiveComponents = [];
  }

  hasUnsaved() {
    const components = this.getRegisteredCanDeactivateComponents();
    
    return components.some(component => {
      // console.log(component, component.hasUnsavedChanges());
      return component.hasUnsavedChanges();
    });
  }

  reloadPage() {
    window.location.reload();
  }

  scrollIntoFormError(formElementId:string, invalidClass:string = '.ng-invalid') {
    const formElement = document.getElementById(formElementId);
    const firstInvalidElement = formElement.querySelector(invalidClass)
    
    firstInvalidElement.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    })
    
  }

  setImageMaxFileuUploadLimit(limit: number) {
    this.imageMaxFileUploadLimit = limit;
  }

  isImageLengthValid(file:File) {
    const maxMbSize = this.imageMaxFileUploadLimit;
    const maxFileSize = maxMbSize * 1024;

    return file.size <= maxFileSize * 1024;
  }

  showImageLengthInvalidError() {
    this.dialogService
        .confirm({
          title: "Warning",
          message: `A file(s) exceeded max file size of ${this.imageMaxFileUploadLimit}mb. Please upload again.`,
          hasCancel: false,
          button: "Okay"
        });
  }

  getValidRegistrationEmail():string{
    if(!this.validRegistrationEmail){
      throw new Error("Valid Email is not set")
    }
    return this.validRegistrationEmail;
  }

  setValidRegistrationEmail(email:string){
    this.validRegistrationEmail = email;
  }

  generateImageObjForRequest(imageFile:ImageFile, usePrefix:boolean = true){
    // prefix is from host. its automatically added in the presigned url when UI uploads.
    const prefix = usePrefix ? 'ofw/' : '';
    return {
      s3_filename: imageFile.keyName,
      original_filename: imageFile.name,
      s3_bucket_location: prefix + imageFile.keyName,
      s3_key: prefix + imageFile.keyName
    }
  }

  /**
   * Runs a code with a specified delay.
   * Useful for formGroups that constrols are initialized in child.
   * NOTE: 'ERROR Error: NG0100: ExpressionChangedAfterItHasBeenCheckedError:' might still be encountered. But it should not be of a concern.
   * The issue is caused by the fact that the child component is initialized after the parent component. And patching of the data in the form
   * is then done right after the form has been checked. A fix is to delay the patching hence this function. But issue might still occur and should not
   * be a concern or affect the process.
   * @param callback code to run after delay. callback will be called with no arguments. 
   * @param delayMs delay in milis
   */
  runWithDelay(callback:()=>void, delayMs:number = 0){
    setTimeout(callback, delayMs);
  }

  setDashboardFilterState(tableFilterMode:string, mode:string){
    const keyName = 'tableFilterMode' + mode;
    sessionStorage.setItem(keyName, tableFilterMode);
  }

  getDashboardFilterState(mode:string):bookingType{
    // will return SEA by default if item is not found
    const keyName = 'tableFilterMode' + mode;
    return sessionStorage.getItem(keyName) === bookingType.Air ? bookingType.Air : bookingType.Sea;
  }

  /**
   * Formats the item list text
   * @param data array of data
   * @returns return array of 'name/description (country_desc)
   */
  getFormattedDropdownData(data:any[]):any[]{
    return data.map((item) => {
      item.description = `${item.description ? item.description : item.name} (${item?.country_desc})` 
      return item;
    })
  }

  getElapseDays(fromDate:string, toDate:string = null):string{
    const localDate = this.getDateTimeLocal({date:fromDate})
    if(toDate){
      return moment(toDate).diff(localDate,'days').toString();
    } else {
      return moment().diff(localDate,'days').toString();
    }
  }

  /**
   * Get actual status from actual_status object from host.
   * Make sure element has actual_status object
   */
  getActualBookingStatus(data){
    const isOnhold = data?.actual_status?.is_onhold === 1;
    const onHoldIdentifier = this.languageService.getTranslation("ONHOLD_INDENTIFIER",null);
    return `${data?.actual_status?.description} ${isOnhold ? onHoldIdentifier : ""}` 
  }

  getYearStartEndDT():any{
    let currentYear = new Date().getFullYear();
    let startMonth = currentYear + "-01-01";
    let endMonth = currentYear + "-12-31";
    return {startMonth, endMonth}
  }
  
}
